export default __webpack_public_path__ + "static/Foodservice-Photo1-a39dcec7c4b2c5286acd6553d86beed4.png";